import { render, staticRenderFns } from "./Qr.vue?vue&type=template&id=c0513b6c&"
import script from "./Qr.vue?vue&type=script&lang=ts&"
export * from "./Qr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports